// extracted by mini-css-extract-plugin
export default {"wrapper":"lC-z","viewport":"mC-z","container":"nC-z","slide":"oC-z"};